import React from "react";
import styles from "./FloatingActionButton.module.css";
import {
	primaryBoxShadow,
	titleXL,
	fw500,
	primaryColor,
	primaryTextColor,
} from "../../../Global.module.css";

export default function FloatingActionButton({ leading, text, action }) {
	return (
		<button
			className={`${styles.cta} ${primaryBoxShadow}`}
			onClick={!action ? null : () => action()}
		>
			<span className={`${primaryColor} ${styles.addIcon}`}>
				{leading}
			</span>{" "}
			<p className={`${titleXL} ${fw500} ${primaryTextColor}`}>{text}</p>
		</button>
	);
}
